import ptBrTranslations from './pt-br'

export default {
  'pt-BR': ptBrTranslations
}